/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBadgeUp = createReactComponent("outline", "arrow-badge-up", "IconArrowBadgeUp", [["path", { "d": "M17 11v6l-5 -4l-5 4v-6l5 -4z", "key": "svg-0" }]]);

export { IconArrowBadgeUp as default };
//# sourceMappingURL=IconArrowBadgeUp.mjs.map
